module.exports = __webpack_public_path__ + "img/ui-book-selector.fb689cb0.png";